export default "__VITE_ASSET__DfIB5Xgv__"